//------------------------------------------------------------------------------
// This file is auto-generated.
//------------------------------------------------------------------------------
// This file was generated by NTypewriter from the C# ViewModel class with the
// same class/interface name.
//
// Do not change this file.  Any changes may cause incorrect behaviour and will
// be lost if the code is regenerated.
//------------------------------------------------------------------------------

import { ItemBase } from '../internal/ItemBase';

export class CalendarBookingSearchOptions extends ItemBase {
    ExistingEvents: boolean | null = null;
    MakeUpCreditRequired: boolean | null = null;
    TeacherIDs: string[] = [];
    StartDate: string = "1970-01-01T00:00:00";
    EndDate: string = "1970-01-01T00:00:00";
    AllDay: boolean | null = null;
    EventCategoryIDs: string[] = [];
    EventLocationIDs: string[] = [];
    StudentIDs: string[] = [];
    RescheduleEventID: string | null = null;

    constructor(initializer?: Partial<CalendarBookingSearchOptions>) {
        super();
        if (initializer) {
            Object.assign(this, initializer);
        }
    }

    static readonly ClassName: string = "CalendarBookingSearchOptions";
}
